(function () {
  const MAX_ATTEMPTS = 12;
  const RETRY_MS = 500;

  function initJudgemeIn(root) {
    const widget =
      root.querySelector('#judgeme_product_reviews') || root.querySelector('.jdgm-review-widget');
    if (!widget) return;

    const hasContent = () => widget.children.length > 0 || widget.innerHTML.trim().length > 50;

    const runPreloader = () => {
      if (typeof window.jdgmPreloader === 'function') {
        window.jdgmPreloader();
        return true;
      }
      if (window.jdgm?.widget?.api?.render) {
        window.jdgm.widget.api.render(widget);
        return true;
      }
      if (typeof window.jdgm?.runWidgets === 'function') {
        window.jdgm.runWidgets();
        return true;
      }
      return false;
    };

    const retry = (attempt) => {
      if (hasContent()) return;
      runPreloader();
      if (attempt < MAX_ATTEMPTS && !hasContent()) {
        setTimeout(() => retry(attempt + 1), RETRY_MS);
      }
    };

    retry(0);
  }

  function initAll() {
    document.querySelectorAll('[data-gt-judgeme-reviews]').forEach(initJudgemeIn);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('product-info:loaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
